document.addEventListener('turbolinks:load', function() {
  document.querySelectorAll('[data-cda-admin-season]').forEach(function(card) {
    var from = card.querySelector('[data-cda-admin-season-from]');
    var to = card.querySelector('[data-cda-admin-season-to]');

    card.querySelector('[data-cda-admin-season-suggest]').addEventListener('click', function() {
      from.value = card.getAttribute('data-suggested-from');
      to.value = card.getAttribute('data-suggested-to');
    });

    var stop = card.querySelector('[data-cda-admin-season-stop]');
    if (stop) {
      stop.addEventListener('click', function(event) {
        if (!window.confirm(stop.getAttribute('data-confirm-text'))) event.preventDefault();
      });
    }
  });
});
